export enum ComplaintTypeEnum {
  COMPLAIN = "Complain",
  SUGGESTION = "Suggestion",
  DELETE_ACCOUNT_REQUEST = "DeleteAccountRequest",
  CONTACT_US = "ContactUs",
}
